










































































































import {
  defineComponent,
  computed,
  Ref,
  ref,
  nextTick,
  ComponentInternalInstance,
  getCurrentInstance,
  reactive,
} from '@vue/composition-api';
import { TreeNodeModel } from 'tdesign-vue';
import { RefreshIcon, AddIcon, SearchIcon } from 'tdesign-icons-vue';

// 引入组件
import TeamTree from '@/renderer/components/TeamTree/index.vue';
import memberTable from '@/renderer/views/desktop/ManageConsole/TeamManagement/components/memberTable.vue';
import createOrEdit from '@/renderer/views/desktop/ManageConsole/TeamManagement/components/createOrEdit.vue';
import deleteTeamDialog from '@/renderer/views/desktop/ManageConsole/TeamManagement/components/deleteTeam.vue';
import Menu from '@/renderer/components/Menu/Menu.vue';
import MenuItem from '@/renderer/components/Menu/MenuItem.vue';
import CoLevelHelp, { helpHandler } from '@/renderer/components/dialog/AddTransfer/components/coLevelHelp.vue';
import i18n, { i18n_t } from '@/locales/i18n';

// 引入 compositions
import teamHandler from '@/renderer/views/desktop/ManageConsole/TeamManagement/compositions/teamHandler';
import treeHandler from '@/renderer/components/TeamTree/compositions/treeHandler';

// 引入工具类
import tips from '@/renderer/scripts/utils/tips';
import { formatSize } from '@/renderer/scripts/utils/tools/index';
import { SMH } from '@/renderer/scripts/smh';
import store from '@/renderer/store';
import { getCheckManagementPermission } from '@/renderer/scripts/utils/UserRole';
import storage from '@/renderer/scripts/utils/storage';

// 引入组件

interface CurrentNode {
  id: number;
  name: string;
  path: string[];
  isRoot: boolean;
  space: string;
  used: string;
  defaultRoleId: number;
  noSpace?: boolean;
}
export default defineComponent({
  components: {
    RefreshIcon,
    AddIcon,
    SearchIcon,
    TeamTree,
    memberTable,
    createOrEdit,
    deleteTeamDialog,
    Menu,
    MenuItem,
    CoLevelHelp,
  },
  setup() {
    const currComponent = getCurrentInstance() as ComponentInternalInstance;
    const rootId = ref(-1);

    // 新建子团队标识
    const definiteTeam = ref(false);
    const deletingTeam = ref(false);

    // 弹窗
    const createOrEditDialogShow = ref(false);
    const dialogType = ref('');
    const deleteDialogShow = ref(false);
    const defaultRoleId = computed(() => store.getters.defaultRoleId);
    // 当前操作节点
    const currentNode = reactive<CurrentNode>({
      id: -1,
      name: '',
      path: [],
      isRoot: false,
      space: '',
      used: '',
      defaultRoleId: defaultRoleId.value,
    });
    const isSharedSpaceSize = ref(false);
    const { show: showHelp, openHelp } = helpHandler();

    // 父节点(编辑删除需要)
    const parentName = ref('');
    const parentId = ref(-1);
    const teamData: Ref<SMH.TeamTreeNode[]> = ref([]);
    const { keyword, orgAvailableSpace, createTeam, editTeam, deleteTeam, listTeamSpace, listTeam, getOrgSpaceInfo } =
      teamHandler(0, true);
    const { findTeamIdByPath } = treeHandler({
      checkPermission: 1,
      needCheckManagementPermission: true,
      withPath: true,
    });

    // 当前节点空间使用大小
    const spaceTotal = computed(() => {
      const sizeInfo = formatSize(currentNode.space || orgAvailableSpace.value);
      return `${sizeInfo.size}${sizeInfo.unit}`;
    });
    const spaceUsed = computed(() => {
      const sizeInfo = formatSize(currentNode.used);
      return `${sizeInfo.size}${sizeInfo.unit}`;
    });

    const spaceTips = computed(() => {
      const tipsMap = {
        noSpace: i18n_t(
          '团队空间：该团队已设置为不分配企业空间，可在管理中心查看该团队的组织框架，团队成员适用团队分配及文件共享。',
        ),
        sharedSpace: i18n_t('团队空间：已使用{slot1} | 剩余可用{slot2}', {
          slot1: spaceUsed.value,
          slot2: spaceTotal.value,
        }),
        customSpace: i18n_t('团队空间：已使用{slot1} / 共{slot2}', { slot1: spaceUsed.value, slot2: spaceTotal.value }),
      };
      // eslint-disable-next-line no-nested-ternary
      const tips = currentNode.noSpace
        ? tipsMap.noSpace
        : isSharedSpaceSize.value
        ? tipsMap.sharedSpace
        : tipsMap.customSpace;
      return tips;
    });

    const methods = {
      // 树节点切换
      teamSelectChange(node: TreeNodeModel) {
        if (!node) {
          currentNode.id = -1;
          currentNode.name = '';
          currentNode.isRoot = false;
          return;
        }
        const { id, name, path, noSpace } = node.data;
        currentNode.id = id;
        currentNode.name = name;
        currentNode.path = path;
        currentNode.isRoot = id === rootId.value;
        currentNode.defaultRoleId = +node.data.defaultRoleId || defaultRoleId.value;
        currentNode.noSpace = noSpace;
        const parentNode = !currentNode.isRoot && node.getParent?.();
        if (currentNode.isRoot || !parentNode) {
          parentName.value = name;
          parentId.value = id;
        } else {
          parentName.value = parentNode.data.name;
          parentId.value = node.data.parentId;
        }
        methods.getTeamSpaceInfo(id);
      },
      // 打开新建/编辑团队弹窗
      async openCreateOrEditDialog(type: string, addSonTeam: boolean) {
        let propTreeData: SMH.TeamTreeNode[] = [];
        // 只有新建团队时，需要统一获取树节点并展开
        if (type === 'add' && !addSonTeam) {
          // 暂时屏蔽loading
          // tips.loading('正在加载');
          propTreeData = await methods.findTreeNode(currentNode.path);
          // tips.success('加载完成');
        }
        // const { teamTree }: any = (currComponent as ComponentInternalInstance).refs;
        teamData.value = propTreeData; // teamTree.treeData;
        definiteTeam.value = !!addSonTeam;
        dialogType.value = type;
        createOrEditDialogShow.value = true;
      },
      async findTreeNode(path: string[]) {
        const res = await listTeam({ teamId: '', withPath: true });
        if (!res.children) {
          res.children = [];
        }
        res.children.forEach((item: any) => {
          item.children = item.children && item.children.length > 0;
        });
        await findTeamIdByPath(path, res);
        // 过滤根团队（团队管理员即便无根团队权限，后端仍然返回根目录）
        const { canManageTeams } = store.getters.userBaseInfo;
        const checkManagementPermission = await getCheckManagementPermission();
        if (!checkManagementPermission || canManageTeams?.includes(res.id)) {
          return [res];
        }
        return res.children;
      },
      // 保存
      async submitUpdateTeam(data: SMH.TeamInfo, isNewOpenSpace: boolean) {
        if (dialogType.value === 'add') {
          this.addTeam(data);
        } else {
          this.editTeam(data, isNewOpenSpace);
        }
      },
      // 添加团队
      async addTeam(data: SMH.TeamInfo) {
        let id;
        try {
          const res = await createTeam(data);
          id = res.id;
        } catch (e) {
          return;
        }
        createOrEditDialogShow.value = false;
        const { teamTree }: any = (currComponent as ComponentInternalInstance).refs;
        const { name, parentId, parentName, noSpace } = data;
        const parents = teamTree.getParents(parentId);
        const path = parents.map((item: any) => item.label).reverse();
        path.push(...[parentName, name]);
        const newNode = {
          id,
          name,
          parentId,
          children: false,
          path,
          userCount: 0,
          defaultRoleId: data.defaultRoleId,
          noSpace,
        };
        teamTree.appendNode(newNode, parentId);
        tips.success(i18n_t('新建成功'));
      },
      // 编辑团队
      async editTeam(data: SMH.TeamInfo, isNewOpenSpace: boolean) {
        try {
          await editTeam(currentNode.id, data, isNewOpenSpace);
        } catch (e) {
          return;
        }
        createOrEditDialogShow.value = false;
        const { name, spaceQuotaSize, defaultRoleId } = data;
        const noSpace = isNewOpenSpace ? false : undefined;
        currentNode.name = name;
        currentNode.space = spaceQuotaSize;
        currentNode.defaultRoleId = defaultRoleId;
        currentNode.noSpace = noSpace;
        const { teamTree }: any = (currComponent as ComponentInternalInstance).refs;
        teamTree.editNode({ name, space: spaceQuotaSize, defaultRoleId, noSpace });
        tips.success(i18n_t('修改成功'));
      },
      // 确认删除团队
      async submitDeleteTeam(toTeam: boolean, toDirPath: string) {
        if (deletingTeam.value) return;
        deletingTeam.value = true;
        const currentPath = currentNode.path;
        try {
          const toTeamId = toTeam ? parentId.value : '';
          await deleteTeam(currentNode.id, toTeamId, toDirPath);
          deletingTeam.value = false;
          // 如果删除的团队路径已经在本地中了，清空掉本地存储
          const teamPathInfo = storage.get(storage.StoreKey.TEAM_PATH) as TeamPathStorageInfo;
          if (teamPathInfo) {
            const { path } = teamPathInfo;
            const flag = path && currentPath.every((val, i) => val === path[i]);
            if (flag) {
              storage.del(storage.StoreKey.TEAM_PATH);
            }
          }
        } catch (e) {
          deletingTeam.value = false;
          return;
        }
        deleteDialogShow.value = false;
        const { teamTree }: any = (currComponent as ComponentInternalInstance).refs;
        teamTree.deleteNode();
        tips.success(i18n_t('删除成功'));
      },
      // 查询团队空间
      async getTeamSpaceInfo(id: number) {
        try {
          const { capacity, size } = await listTeamSpace(id);
          isSharedSpaceSize.value = capacity === null;
          if (capacity === null) {
            getOrgSpaceInfo(0);
          }
          currentNode.space = capacity;
          currentNode.used = size;
        } catch (e) {
          //
        }
      },
      // 搜索团队
      searchTeam() {
        const { teamTree }: any = (currComponent as ComponentInternalInstance).refs;
        teamTree.searchNode();
      },
      // 清空搜索
      clearSearchTeam() {
        keyword.value = '';
        nextTick(() => {
          methods.searchTeam();
        });
      },
      // 刷新团队
      freshTeamTree() {
        const { teamTree }: any = (currComponent as ComponentInternalInstance).refs;
        teamTree.initData();
      },
      /**
       * 右键菜单回调事件
       */
      rightClickListenerCallback(event: any): boolean {
        const { path } = event;
        const CLASS_NAME_LIST = ['t-tree__item', 't-tree__label'];
        let isContinue = false;
        for (let index = 0; index < path.length; index++) {
          const { className } = path[index];
          if (
            className &&
            (className.indexOf(CLASS_NAME_LIST[0]) !== -1 || className.indexOf(CLASS_NAME_LIST[1]) !== -1)
          ) {
            path[index].click();
            isContinue = true;
            break;
          }
        }
        return isContinue;
      },
    };
    return {
      rootId,
      currentNode,
      isSharedSpaceSize,
      spaceTotal,
      spaceUsed,
      createOrEditDialogShow,
      dialogType,
      definiteTeam,
      deleteDialogShow,
      parentName,
      parentId,
      teamData,
      keyword,
      showHelp,
      spaceTips,
      ...methods,
      openHelp,
    };
  },
});
